import React, { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useAssistant } from '../hooks/useAssistant';
import ChatHistory from '../../../components/ChatHistory/ChatHistory';
import WelcomeModal from '../../../components/WelcomeModal/WelcomeModal';
// import Recommendations from '../../../components/Recommendations/Recommendations';
import Header from '../../../components/Header/Header';
import ErrorPopup from '../../../components/ErrorPopup/ErrorPopup';
import { createEmptyThread } from '../services/openai';
import './Chat.css';

const Chat = () => {
  const { t } = useTranslation();
  const { 
    question, 
    setQuestion, 
    error, 
    setError,
    chatHistory, 
    isProcessing, 
    handleFormSubmit, 
    // handleRecommendationSubmit, 
    chatEndRef, 
    handleUserScroll, 
    resetChat, 
    isTyping,
    setChatHistory,
    processMessage
  } = useAssistant();
  const inputRef = useRef(null);
  const [showWelcomeModal, setShowWelcomeModal] = useState(true);
  const [showStartNewChat, setShowStartNewChat] = useState(false);
  // const [showRecommendations, setShowRecommendations] = useState(false);
  const isInitialMount = useRef(true);

  useEffect(() => {
    const hideWelcomeModal = localStorage.getItem('hideWelcomeModal');
    const threadId = localStorage.getItem('threadId');
    if (hideWelcomeModal) {
      setShowWelcomeModal(false);
    }
    if (!threadId) {
      setShowStartNewChat(true);
      // setShowRecommendations(false);
    }
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    // const threadId = localStorage.getItem('threadId');
    // Prikaži priporočila samo če je threadId prisoten in ni zgodovine pogovora
    // if (threadId && chatHistory.length === 0) {
    //   setShowRecommendations(true);
    // } else {
    //   setShowRecommendations(false);
    // }
  }, [chatHistory]);

  const handleWelcomeModalClose = () => {
    const hideCheckbox = document.querySelector('.welcome-modal-checkbox input');
    if (hideCheckbox && hideCheckbox.checked) {
      localStorage.setItem('hideWelcomeModal', 'true');
    }
    setShowWelcomeModal(false);
  };

  const handleStartNewChat = async () => {
    try {
      await createEmptyThread();
      setChatHistory([]);
      setShowStartNewChat(false);
      setError(null);
      // Pošlji pozdravno sporočilo kot uporabnik, da asistent odgovori
      const greeting = t('startGreeting');
      if (typeof processMessage === 'function') {
        await processMessage(greeting);
      }
    } catch (error) {
      setError('Failed to start new chat');
      console.error('Error starting new chat:', error);
    }
  };

  // Razširjena funkcija resetChat, ki ponastavi stanje in prikaže gumb za začetek novega pogovora
  const handleResetChat = () => {
    resetChat();
    setShowStartNewChat(true);
    // setShowRecommendations(false);
  };

  const handleInputChange = (e) => {
    setQuestion(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleFormSubmitWithReset(e);
    }
  };

  const handleFormSubmitWithReset = (e) => {
    // setShowRecommendations(false);
    handleFormSubmit(e);
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';
    }
  };

  // const handleRecommendationSelect = (rec) => {
  //   // setShowRecommendations(false);
  //   handleRecommendationSubmit(rec);
  // };

  return (
    <motion.div
      className="chat-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {error && (
        <ErrorPopup
          message={error}
          onClose={() => setError('')}
          type="error"
        />
      )}
      {showWelcomeModal && <WelcomeModal onClose={handleWelcomeModalClose} />}
      <Header onResetChat={handleResetChat} />
      <ChatHistory 
        chatHistory={chatHistory} 
        chatEndRef={chatEndRef} 
        handleUserScroll={handleUserScroll}
        isTyping={isTyping}
      />
      {/* {showRecommendations && <Recommendations onSelect={handleRecommendationSelect} />} */}
      {showStartNewChat && (
        <div className="start-new-chat-container">
          <button className="start-new-chat-button" onClick={handleStartNewChat}>
            {t('startConversation')}
          </button>
        </div>
      )}
      {!showStartNewChat && (
        <div className="chat-footer">
          <form onSubmit={handleFormSubmitWithReset} className="question-form">
            <textarea
              ref={inputRef}
              value={question}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              placeholder={t('messagePlaceholder')}
              required
              className="question-input"
              disabled={isProcessing}
              rows="1"
            />
            <button type="submit" className="submit-button" disabled={!question || isProcessing}>
              <i className="fas fa-arrow-up"></i>
            </button>
          </form>
        </div>
      )}
    </motion.div>
  );
};

export default Chat;
